import { createPutEndpoint } from '@sonar-software/sonar-http';

export type PutSonarObjectStakeholdersRequest = {
	sonarObjectId: number;
	stakeholderIds: Array<number>;
};

export const putSonarObjectStakeholders = createPutEndpoint<PutSonarObjectStakeholdersRequest>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/stakeholders`
);
